import Content from "@src/components/common/Content";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "@src/utils/axios";
import Loader from "@src/ui-component/Loader";
import AppPagination from "@src/components/common/AppPagination";
import { ExerciseRow } from "./list/Style1/DataList";
import { useSelector } from "@src/store";
import { selectFolder } from "@src/store/slices/menu";

const Folder = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [exercises, setExercises] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [paging, setPaging] = useState({ limit: 10, currentPage: 1 });
  const [search, setSearch] = useState("");

  const folder = useSelector(selectFolder(id));

  const col = ["Image", "Title", "Subtitle", "Description"];

  const searchedExercises = useMemo(() => {
    const regex = new RegExp(
      search
        .split(" ")
        .map((word) => `(?=.*${word})`)
        .join(""),
      "i"
    );
    return exercises.filter(({ name }) => regex.test(name));
  }, [search, exercises]);

  const currentPageData = useMemo(() => {
    const { limit, currentPage } = paging;
    const min = limit * (currentPage - 1);
    const max = limit * currentPage + 1;
    return searchedExercises.slice(min, max);
  }, [paging, searchedExercises]);

  useEffect(() => {
    const fetchExercises = async () => {
      setIsLoading(true);
      try {
        const res = await axios.get(`/exercises/folders/${id}`);
        setExercises(res.data);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        throw error;
      }
    };
    fetchExercises();
  }, [id]);

  const onSearchEnd = (val) => {
    setSearch(val);
  };

  return (
    <Content
      heading={folder?.title || ""}
      addHeading="Add Exercise"
      onClickAdd={() => navigate("/add-exercise")}
      hasSearch={true}
      onSearchEnd={onSearchEnd}
    >
      <>
        {isLoading && <Loader />}
        {!isLoading && (
          <>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    {col.map((item, index) => (
                      <TableCell key={`col-${index}`}>{item}</TableCell>
                    ))}
                    <TableCell align="center" sx={{ pr: 3 }}>
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {searchedExercises.length > 0 &&
                    currentPageData.map((exercise) => (
                      <ExerciseRow key={exercise.id} exercise={exercise} />
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <AppPagination
              data={searchedExercises}
              totalPages={Math.ceil(searchedExercises.length / paging.limit)}
              onChangePage={(e, val) => {
                setPaging({ ...paging, currentPage: val });
              }}
            />
          </>
        )}
      </>
    </Content>
  );
};

export default Folder;
